// csak a kapcsolódási adatok tárolására van
export default {
	key: null,
	cluster: null,
}
